import { useCurrentStore } from '@hooks/useCurrentStore.ts'

import type { StoreRole } from '@state/user.ts'

const TASK_WRITE_ROLES: StoreRole[] = ['STORE_MANAGER', 'STORE_EMPLOYEE']

function useCanWriteTasks() {
  const { role } = useCurrentStore()
  return TASK_WRITE_ROLES.includes(role)
}

export default useCanWriteTasks
